  import * as ActionTypes from "../Types/ActionTypes";

  export const BillDashboardMain = (
    state = {
      isLoading: false,
      billDashboardState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.FINAL_BILLS_FINANCEANALYTICS_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.FINAL_BILLS_FINANCEANALYTICS:
        return {
          ...state,
          isLoading: false,
          billDashboardState: action.payload,
        };

      case ActionTypes.FINAL_BILLS_FINANCEANALYTICS_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
